import React, { useState, useCallback, useEffect } from "react";
import MainLayout from "components/MainLayout";
import CloseButton from "@hs/close-button";
import TextEditorControl from "components/ExtraAttributes/EditorControl/TextEditorControl";
// import CheckboxEditorControl from "components/ExtraAttributes/EditorControl/CheckboxEditorControl";
import { LinkViewer } from "components/ExtraAttributes/ViewerControl/LinkViewerControl";
import Formsy from "formsy-react";
import { getClassNames, getLocalizedText } from "data/utils";
import { produce } from "immer";

const UrlPicker = ({
    itemUri,
    /*title,
    caption,
    icon,
    isIconLast,*/
    onItemUriSelect,
    onClose,
    topRowBefore,
}) => {
    const [canSubmit, setCanSubmit] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [fields, setFields] = useState({
        itemUri,
        /*title,
        caption,
        icon,
        isIconLast,*/
    });
    const enableSubmit = useCallback(() => setCanSubmit(true), []);
    const disableSubmit = useCallback(() => setCanSubmit(false), []);
    const handleChange = useCallback(
        (field: string, value: any) =>
            setFields((fields) =>
                produce(fields, (draft) => {
                    draft[field] = value;
                })
            ),
        []
    );
    useEffect(() => {
        onItemUriSelect(fields.itemUri);
    }, []);

    return (
        <MainLayout
            name="urlPicker"
            itemUri="urlPicker"
            breadcrumbReadonly={true}
            actionsDisabled={true}
            topRowBefore={topRowBefore}
            topRowEnd={onClose && <CloseButton onClick={onClose} />}
        >
            <Formsy
                onValidSubmit={onClose}
                onValid={enableSubmit}
                onInvalid={disableSubmit}
                autoComplete="off"
                className={getClassNames("form-inline", "ip-form")}
            >
                <TextEditorControl
                    header={getLocalizedText("$picker:itemUri.label")}
                    name="itemUri"
                    placeholder={getLocalizedText(
                        "$picker:itemUri.placeholder"
                    )}
                    isRequired={true}
                    value={fields.itemUri}
                    onChange={handleChange}
                />
                {/*(
                    <>
                        <TextEditorControl
                            header={getLocalizedText("$picker:title.label")}
                            name="title"
                            placeholder={getLocalizedText(
                                "$picker:title.placeholder"
                            )}
                            isRequired={false}
                            value={fields.title}
                            onChange={handleChange}
                        />
                        <TextEditorControl
                            header={getLocalizedText(
                                "$picker:caption.label"
                            )}
                            name="caption"
                            placeholder={getLocalizedText(
                                "$picker:caption.placeholder"
                            )}
                            isRequired={false}
                            value={fields.caption}
                            onChange={handleChange}
                        />
                        <TextEditorControl
                            header={getLocalizedText("$picker:icon.label")}
                            name="icon"
                            placeholder={getLocalizedText(
                                "$picker:icon.placeholder"
                            )}
                            isRequired={false}
                            value={fields.icon}
                            onChange={handleChange}
                        />
                        <CheckboxEditorControl
                            header={getLocalizedText(
                                "$picker:isIconLast.label"
                            )}
                            name="isIconLast"
                            isRequired={false}
                            value={fields.isIconLast}
                            onChange={handleChange}
                        />
                        <LinkViewer
                            {...fields}
                            value={fields.itemUri}
                            target="_blank"
                        />
                    </>
                )} */}
            </Formsy>
        </MainLayout>
    );
};
UrlPicker.displayName = "PickerModal.UrlPicker";

export default UrlPicker;
